export const FRAME_MS = 1000 / 60;
export const SCREEN_PREP_STEPS = 2;

/** Keep presentation at 60 Hz (30 in fallback), independent of panel refresh rate. */
export class DrawClock {
  private elapsed = 0;

  tick(interval: number, quality: number): boolean {
    const step = quality === 0 ? FRAME_MS * 2 : FRAME_MS;
    this.elapsed += Math.max(0, Math.min(250, interval));
    if (this.elapsed + 0.001 < step) return false;
    this.elapsed = Math.max(0, this.elapsed - Math.floor((this.elapsed + 0.001) / step) * step);
    return true;
  }

  reset() { this.elapsed = 0; }
}

export function foliageCadence(quality = 3): number {
  return quality >= 3 ? 3 : quality >= 2 ? 6 : quality >= 1 ? 10 : 15;
}

/** Three seconds of elapsed frames, not 180 frames on an already struggling device. */
export function qualityWindowReady(elapsed: number, frames: number): boolean {
  return elapsed >= 3000 && frames >= 12;
}
